module.exports = __webpack_public_path__ + "static/media/checkYellow.a535b4d2.svg";